
class ConfigManager {
  private static instance: ConfigManager;
  private config?: Config;

  constructor() {
    if (ConfigManager.instance) {
      throw new Error("Error: Instantiation failed: Use BaseConfig.getInstance() instead of new.");
    }
    ConfigManager.instance = this;
  }

  static getInstance() {
    if (!ConfigManager.instance) {
      ConfigManager.instance = new ConfigManager();
    }
    return ConfigManager.instance;
  }

  getConfig() {
    return this.config;
  }

  setConfig(config: Config){
    this.config = config;
  }
}

export const configManager = ConfigManager.getInstance();

export interface Config {
  api: ApiConfig;
  cognito: CognitoConfig;
  hubspot: HubspotConfig;
  salesforce: SalesforceConfig;
  google: GoogleConfig;
}

interface GoogleConfig {
  clientId: string;
}

interface ApiConfig {
  url: string;
  httpProtocol: string;
}

interface CognitoConfig {
  authority: string;
  client_id: string;
  client_secret?: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  cognito_domain: string;
  logout_uri: string;
}

interface HubspotConfig {
  clientId: string;
  redirectUri: string;
  scopes: string;
  baseAuthUrl: string;
}

interface SalesforceConfig {
  baseAuthUrl: string;
  clientId: string;
  redirectUri: string;
  scopes: string;
}
